/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_Point_2_TextInputs */

const en_visa_eb4_point_2_text = /** @type {(inputs: Visa_Eb4_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because the rules vary substantially across EB-4 subcategories, accurate screening at the outset is especially important.`)
};

const pt_visa_eb4_point_2_text = /** @type {(inputs: Visa_Eb4_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as regras variam substancialmente entre as subcategorias do EB-4, a triagem precisa desde o início é especialmente importante.`)
};

const es_visa_eb4_point_2_text = /** @type {(inputs: Visa_Eb4_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dado que las reglas varían sustancialmente entre las subcategorías del EB-4, la evaluación precisa desde el principio es especialmente importante.`)
};

/**
* | output |
* | --- |
* | "Because the rules vary substantially across EB-4 subcategories, accurate screening at the outset is especially important." |
*
* @param {Visa_Eb4_Point_2_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_point_2_text = /** @type {((inputs?: Visa_Eb4_Point_2_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_Point_2_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_point_2_text(inputs)
	if (locale === "es") return es_visa_eb4_point_2_text(inputs)
	return en_visa_eb4_point_2_text(inputs)
});